import { apiClient } from "./httpClient";
import { unwrapEnvelope, unwrapList, unwrapMeta } from "./response";

export const notificationsApi = {
  async list(params = {}) {
    const response = await apiClient.get("/notifications", { params });
    return {
      data: unwrapList(response.data),
      meta: unwrapMeta(response.data, {})
    };
  },

  async create(payload) {
    const response = await apiClient.post("/notifications", payload);
    return unwrapEnvelope(response.data, null);
  },

  async markRead(id) {
    const response = await apiClient.patch(`/notifications/${id}/read`);
    return unwrapEnvelope(response.data, null);
  },

  async markAllRead() {
    const response = await apiClient.patch("/notifications/read-all");
    return unwrapEnvelope(response.data, null);
  }
};
